import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full h-full flex"
}
const _hoisted_2 = {
  key: 1,
  class: "flex flex-col py-5 px-4 justify-center space-y-10"
}
const _hoisted_3 = { class: "flex flex-col space-y-2" }
const _hoisted_4 = { class: "flex flex-col space-y-1" }
const _hoisted_5 = { class: "text-left text-sm" }
const _hoisted_6 = { class: "flex m-auto space-x-2.5" }
const _hoisted_7 = { class: "my-auto pt-0.5" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }

import {
  alertController,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar, onIonViewDidEnter,
  useIonRouter,
} from '@ionic/vue';
import {inject, onMounted, reactive, Ref, ref, watch, watchEffect} from 'vue';
import ApiService from "@/services/api/apiService";
import {DateTime} from "luxon";
import MenuButton from "@/components/MenuButton.vue";
import {Preferences} from "@capacitor/preferences";
import {PreferenceKey} from "@/definitions/PreferenceKey";
import {Observable, ObservableEvent} from "@/services/observable/Observable";
import {UserInterface} from "@/interfaces/UserInterface";
import InputCheckbox from "@/components/InputCheckbox.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileSettingsAccount',
  setup(__props) {

const user: Ref<UserInterface | undefined> = inject('user') as Ref<UserInterface | undefined>

const loading = ref(false)
const ionRouter = useIonRouter()
const busy = ref(false)

const goBack = async () => {
  await ionRouter.back()
}

const deleteAccount = async () => {

  const alert = await alertController.create({
    header: 'Delete Account',
    message: 'Are you sure you want to delete your account?\n\n All associated data including images will be removed.',
    buttons: [
      {
        text: 'No',
      },
      {
        text: 'Yes',
        role: 'destructive',
        handler: async () => {
          busy.value = true
          try {
            await ApiService.User().delete()
            await Preferences.clear()
            await Preferences.set({
              key: PreferenceKey.CompletedOnboarding,
              value: DateTime.now().toISO()
            })
            ionRouter.navigate('/', 'back', 'pop')
          } catch (e) {

            busy.value = false
            const alert = await alertController.create({
              header: 'Delete Account',
              message: 'There was a problem whilst attempting to delete your account, please try again. If the issue persists please contact support@thepineapple.app',
              buttons: [
                {
                  text: 'Ok'
                }
              ]
            })
            await alert.present()

          }
        }
      },
    ]
  })

  await alert.present()

}

const edit = async (slug: string) => {
  await ionRouter.navigate({name: `ProfileSettings${slug}`}, 'forward', 'push')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), {
                slot: "start",
                class: "mr-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), {
                    onClick: goBack,
                    class: "bg-brand-dark-gray rounded-md"
                  }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createElementVNode("svg", {
                        class: "",
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M6 11.9961H18",
                          stroke: "white",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }),
                        _createElementVNode("path", {
                          d: "M12 18L6 12L12 6",
                          stroke: "white",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        })
                      ], -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), { class: "text-white font-medium text-2xl" }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("Account", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), { class: "flex h-full w-full" }, {
        default: _withCtx(() => [
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[4] || (_cache[4] = [
                _createElementVNode("div", { class: "m-auto" }, [
                  _createElementVNode("svg", {
                    class: "animate-spin h-10 w-10 text-white",
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("circle", {
                      class: "opacity-25",
                      cx: "12",
                      cy: "12",
                      r: "10",
                      stroke: "currentColor",
                      "stroke-width": "4"
                    }),
                    _createElementVNode("path", {
                      class: "opacity-75",
                      fill: "currentColor",
                      d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    })
                  ])
                ], -1)
              ]))]))
            : _createCommentVNode("", true),
          (!loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(MenuButton, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (edit('Username'))),
                      name: "Username"
                    }, {
                      bottom: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(user).name), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (edit('AccountType'))),
                    class: "flex flex-col space-y-1"
                  }, [
                    (!_unref(user).account_type)
                      ? (_openBlock(), _createBlock(MenuButton, {
                          key: 0,
                          "inline-label": "Account Type",
                          name: "Set..."
                        }))
                      : _createCommentVNode("", true),
                    (_unref(user).account_type)
                      ? (_openBlock(), _createBlock(MenuButton, {
                          key: 1,
                          "inline-label": "Account Type",
                          class: "capitalize",
                          name: `${_unref(user).account_type}`
                        }, null, 8, ["name"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("button", {
                  onClick: deleteAccount,
                  class: "mx-auto w-full flex bg-red-500 rounded-full px-8 h-14 font-medium text-xl text-white transition-all"
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      (!busy.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Delete account"))
                        : _createCommentVNode("", true),
                      (busy.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[5] || (_cache[5] = [
                            _createElementVNode("svg", {
                              class: "animate-spin h-5 w-5 text-white",
                              xmlns: "http://www.w3.org/2000/svg",
                              fill: "none",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("circle", {
                                class: "opacity-25",
                                cx: "12",
                                cy: "12",
                                r: "10",
                                stroke: "currentColor",
                                "stroke-width": "4"
                              }),
                              _createElementVNode("path", {
                                class: "opacity-75",
                                fill: "currentColor",
                                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                              })
                            ], -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})